import { makeStyles } from '@material-ui/core/styles';
import { TableRow } from '@material-ui/core';

interface IProps {
    onClick: (event: React.MouseEvent<HTMLTableRowElement, MouseEvent>) => void
    children: React.ReactNode
}

let useStyles = makeStyles(() => ({
    cursor: {
        cursor: 'pointer'
    }
}));

let ClickableTableRow: React.FC<IProps & Record<string, any>> = ({ children, onClick, ...rest }: IProps) => {
    let classes = useStyles();

    return (
        <TableRow className={classes.cursor} onClick={onClick} {...rest}>
            {children}
        </TableRow>
    )
}

export default ClickableTableRow;